<template>
  <section class="invoice-preview-wrapper">
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'order-list' }">
        ข้อมูลคำสั่งซื้อ
      </b-breadcrumb-item>
      <b-breadcrumb-item active> ดูข้อมูล </b-breadcrumb-item>
    </b-breadcrumb>
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="invoiceData === undefined">
      <h4 class="alert-heading">Error fetching invoice data</h4>
      <div class="alert-body">
        No invoice found with this invoice id. Check
        <b-link class="alert-link" :to="{ name: 'apps-invoice-list' }">
          Invoice List
        </b-link>
        for other invoices.
      </div>
    </b-alert>

    <b-row v-if="invoiceData" class="invoice-preview">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="9" md="8">
        <b-card no-body class="invoice-preview-card">
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">
            <div
              class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
            >
              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">
                  <!-- <logo /> -->
                  <h5 class="text-primary ">
                    ชื่อร้านค้า :
                    <span>{{ saleOrderData.shopName }}</span>
                  </h5>
                </div>
                <!-- <p class="card-text mb-25">
                  รายละเอียดที่อยู่ร้านค้า :
                </p> -->
                <p class="card-text mb-25">
                  รายละเอียดที่อยู่ร้านค้า : {{ saleOrderData.shopAddress }}
                </p>
                <!-- <p class="card-text mb-0">
                  064-85963251
                </p> -->
              </div>

              <!-- Header: Right Content -->
              <div class="mt-md-0 mt-2">
                <!-- <h4 class="invoice-title">
                  Invoice
                  <span class="invoice-number">#{{ invoiceData.id }}</span>
                </h4> -->
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title ">
                    หมายเลขคำสั่งซื้อ :
                  </p>
                  <p class="invoice-date pt-25">
                    {{ saleOrderData.no }}
                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title ">
                    หมายเลข Booking :
                  </p>
                  <p class="invoice-date pt-25">
                    {{ saleOrderData.trackingID }}
                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">วันที่สั่งซื้อ :</p>
                  <p class="invoice-date">
                    {{ saleOrderData.createdOnString }}
                    <!-- {{ saleOrderData.paymentOn.slice(0, 10) }} -->
                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">สถานะการสั่งซื้อ :</p>
                  <p class="invoice-date">
                    {{ saleOrderData.orderStatusString }}
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing" />

          <!-- Invoice Client & Payment Details -->
          <b-card-body v-if="invoiceData.client" class="invoice-padding pt-0">
            <b-row class="invoice-spacing">
              <!-- Col: Invoice To -->
              <b-col cols="12" xl="6" class="p-0">
                <h6 class="mb-2">ชื่อ - นามสกุล ผู้รับสินค้า :</h6>
                <h6 class="mb-25">
                  {{ saleOrderData.shippingAddress.contactName }}
                </h6> </br>

                <h6 class="mb-2">รายละเอียดที่อยู่ผู้รับสินค้า :</h6>
                <p class="card-text mb-25">
                  {{ saleOrderData.shippingAddress.addressLine1 }} ตำบล
                  {{ saleOrderData.shippingAddress.tumbon }} อำเภอ
                  {{ saleOrderData.shippingAddress.amphur }} จังหวัด
                  {{ saleOrderData.shippingAddress.province }}, ประเทศไทย
                </p>
                <p class="card-text mb-25">
                  {{ saleOrderData.phone }}
                </p>
                <!-- <p class="card-text mb-0">
                  {{ invoiceData.client.companyEmail }}
                </p> -->
              </b-col>

              <!-- Col: Payment Details -->
              <b-col
                xl="6"
                cols="12"
                class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
              >
                <div style="width: 22rem">
                  <h6 class="mb-2">รายละเอียดการชำระเงิน :</h6>
                  <table>
                    <tbody>
                      <tr>
                        <td class="pr-1">การชำระเงินทั้งหมด :</td>
                        <td>
                          <span class="font-weight-bold">
                            {{ saleOrderData.orderTotal }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td class="pr-1">วิธีการชำระเงิน :</td>
                        <td>{{ paymentName[saleOrderData.paymentType] }}</td>
                      </tr>
                      <!-- <tr>
                        <td class="pr-1">รายละเอียดการชำระเงิน :</td>
                        <td>{{ saleOrderData.orderStatusString }}</td>
                      </tr> -->
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table-lite
            responsive
            :items="productItems"
            :fields="[
              { key: 'name', label: 'ชื่อสินค้า' },
              { key: 'productPrice', label: 'ราคาต่อชิ้น' },
              { key: 'quantity', label: 'จำนวน' },
              { key: 'itemAmount', label: 'ราคารวม' },
            ]"
          >
            <template #cell(productName)="data">
              {{ data.item.productName || "name" }}
            </template>
            <template #cell(rate)="data"> 5 บาท </template>
            <template #cell(totalAmount)="data">
              {{ data.item.totalAmount }} บาท
            </template>
          </b-table-lite>
          <!-- Invoice Description: Table -->
          <!-- <b-table-lite
            responsive
            :items="invoiceDescription"
            :fields="[
              { key: 'taskDescription', label: 'ชื่อสินค้า' },
              { key: 'rate', label: 'ราคาต่อชิ้น' },
              { key: 'hours', label: 'จำนวน' },
              { key: 'total', label: 'ราคารวม' },
            ]"
          >
            <template #cell(taskDescription)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{ data.item.taskTitle }}
              </b-card-text>
              <b-card-text class="text-nowrap">
                {{ data.item.taskDescription }}
              </b-card-text>
            </template>
          </b-table-lite> -->

          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding pb-0">
            <b-row>
              <!-- Col: Sales Persion -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-0 mt-3"
                order="2"
                order-md="1"
              >
                <b-card-text class="mb-0">
                  <span class="font-weight-bold">ชื่อพนักงาน/ ร้านค้า :</span>
                  <span class="ml-75">{{
                    saleOrderData.employeeShop || "name shop"
                  }}</span>
                </b-card-text>
              </b-col>

              <!-- Col: Total -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-6 d-flex justify-content-end"
                order="1"
                order-md="2"
              >
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">จำนวนสินค้าทั้งหมด :</p>
                    <p class="invoice-total-amount">
                      {{ saleOrderData.itemsTotal }} ชิ้น
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">ยอดรวมสินค้าทั้งหมด :</p>
                    <p class="invoice-total-amount">
                      {{ saleOrderData.subTotal }} บาท
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">ค่าจัดส่งสินค้า :</p>
                    <p class="invoice-total-amount">{{ saleOrderData.shippingFeeAmount }} บาท</p>
                  </div>
                  <hr class="my-50" />
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">การชำระเงินทั้งหมด :</p>
                    <p class="invoice-total-amount">
                      {{ saleOrderData.orderTotal }} บาท
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing" />

          <!-- Note -->
          <!-- <b-card-body class="invoice-padding pt-0">
            <span class="font-weight-bold">Note: </span>
            <span
              >It was a pleasure working with you and your team. We hope you
              will keep us in mind for future freelance projects. Thank
              You!</span
            >
          </b-card-body> -->
        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions">
        <b-card>
          <!-- Button: Send Invoice -->
          <!-- <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-toggle.sidebar-send-invoice
            variant="primary"
            class="mb-75"
            block
          >
            Send Invoice
          </b-button> -->

          <!-- Button: DOwnload -->
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
          >
            ดาวน์โหลด
          </b-button> -->

          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            พิมพ์
          </b-button>

          <!-- Button: Edit -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            v-b-modal.modal-saleorder
          >
            ยกเลิกคำสั่งซื้อ
          </b-button>

          <!-- Button: Add Payment -->
          <!-- <b-button
            v-b-toggle.sidebar-invoice-add-payment
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mb-75"
            block
          >
            Add Payment
          </b-button> -->
        </b-card>
        <b-card>
          <!-- Button: Send Invoice -->
          <b-row class="mb-1">
            <b-col class="d-flex justify-content-between">
              <h5>สถานะการจัดส่ง</h5>
              <h5>วัน/ เวลา ที่จัดส่ง</h5>
            </b-col>
          </b-row>
          <!-- <timeline-card :data="saleOrderData.orderHistoryStatuses" /> -->
          <app-timeline>
              <app-timeline-item
                v-for="status in saleOrderData.orderHistoryStatuses"
                :key="status.orderId"
                :title="สถานะการสั่งซื้อ"
                :subtitle="status.deliveryString"
                :time="status.deliveryDateString"
                variant="success"
              />
            </app-timeline>
        </b-card>
      </b-col>
    </b-row>

    <invoice-sidebar-send-invoice />
    <invoice-sidebar-add-payment />
    <b-modal
      id="modal-saleorder"
      centered
      title="ยกเลิกคำสั่งซื้อ"
      ok-only
      ok-title="บันทึก"
      @ok="handlerDelete"
      ref="modal-saleOrder"
    >
      <b-form-group>
        <v-select
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="option"
        />
      </b-form-group>
    </b-modal>
  </section>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
  BBreadcrumb,
  BBreadcrumbItem,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Ripple from "vue-ripple-directive";
import invoiceStoreModule from "../invoiceStoreModule";
import InvoiceSidebarSendInvoice from "../InvoiceSidebarSendInvoice.vue";
import InvoiceSidebarAddPayment from "../InvoiceSidebarAddPayment.vue";
import TimelineCard from "../TimelineCard.vue";
import saleOrderStore from "../../orderStoreModule";
import vSelect from "vue-select";
import axios, { baseURL } from '@axios'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    TimelineCard,
    Logo,
    InvoiceSidebarAddPayment,
    InvoiceSidebarSendInvoice,
    vSelect,
    BBreadcrumb,
    BBreadcrumbItem,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      paymentName: [
        "CashOnDelivery",
        "QRPayment",
        "TransferMoneyAccount",
        "CreditCard",
        "EWallet",
        "TrueMoney",
        "CounterService",
      ],
      selected: { title: "ผู้ขายไม่ส่งสินค้าเกิน 7 วัน" },

      option: [ { title: "ผู้ขายไม่ส่งสินค้าเกิน 7 วัน" }, { title: "ไม่สามารถติดต่อได้" },{ title: "อื่นๆ" }],
    };
  },
  setup() {
    const invoiceData = ref(null);
    const paymentDetails = ref({});
    const saleOrderData = ref(null);
    const productItems = ref([]);

    // Invoice Description
    // ? Your real data will contain this information
    const invoiceDescription = [
      {
        taskTitle: "Native App Development",
        taskDescription:
          "Developed a full stack native app using React Native, Bootstrap & Python",
        rate: "$60.00",
        hours: "30",
        total: "$1,800.00",
      },
      {
        taskTitle: "UI Kit Design",
        taskDescription:
          "Designed a UI kit for native app using Sketch, Figma & Adobe XD",
        rate: "$60.00",
        hours: "20",
        total: "$1200.00",
      },
    ];

    const INVOICE_APP_STORE_MODULE_NAME = "app-invoice";

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
      store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
        store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME);
    });

    store
      .dispatch("app-invoice/fetchInvoice", { id: "4987" })
      .then((response) => {
        invoiceData.value = response.data.invoice;
        paymentDetails.value = response.data.paymentDetails;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          invoiceData.value = undefined;
        }
      });

    // Set Up store saleOrder
    const SALE_ORDER_STORE_MODULE_NAME = "saleOrder";
    // Register module
    if (!store.hasModule(SALE_ORDER_STORE_MODULE_NAME))
      store.registerModule(SALE_ORDER_STORE_MODULE_NAME, saleOrderStore);

    store
      .dispatch("saleOrder/fetchSaleOrder", {
        id: router.currentRoute.params.id,
      })
      .then((response) => {
        saleOrderData.value = response.data.data;
        productItems.value = response.data.data.items;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          saleOrderData.value = undefined;
        }
      });

    const printInvoice = () => {
      window.print();
    };

    return {
      invoiceData,
      paymentDetails,
      invoiceDescription,
      printInvoice,
      saleOrderData,
      productItems,
    };
  },
  mounted() {
    if (router.currentRoute.params.isEdit == true) {
      this.$refs["modal-saleOrder"].show();
    }
  },
  methods: {
    handlerDelete(){
      const payload = {
              orderId : this.saleOrderData.id,
              reason: this.selected.title
            }
            axios
          .put(`${baseURL}/api/CustomerOrder/Cancel?orderId=${this.saleOrderData.id}`, {payload} )
          .then(response => {
            if (response.status == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `ยกเลิกคำสั่งซื้อสำเร็จ `,
                  icon: 'UserIcon',
                  variant: 'success',
                },
              })
              setTimeout(() => {
                this.$router.go(0);
              }, 1000);
             }
          })
          .catch((error) => {
            console.log("err", error);
          });
    }
    // handlerDelete() {
    //   if (this.selected.title == "ยกเลิก") {
    //     store
    //       .dispatch("saleOrder/deleteSaleOrder", {
    //         id: this.saleOrderData.id,
    //         status: false,
    //       })
    //       .then((response) => {
    //         if (response.status == 200) {
    //           this.$router.push({ name: "order-list" });
    //         }
    //       })
    //       .catch((error) => {
    //         console.log("err", error);
    //       });
    //   } else {
    //     store
    //       .dispatch("saleOrder/deleteSaleOrder", {
    //         id: this.saleOrderData.id,
    //         status: true,
    //       })
    //       .then((response) => {
    //         if (response.status == 200) {
    //           this.$router.push({ name: "order-list" });
    //         }
    //       })
    //       .catch((error) => {
    //         console.log("err", error);
    //       });
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
